import { Card, CardContent } from "@/components/ui/card";
import { fmtDate } from "@/lib/formatters";

function Field({ label, children }) {
  return (
    <div className="space-y-0.5">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-medium">{label}</div>
      <div className="text-sm text-slate-900">{children ?? "—"}</div>
    </div>
  );
}

/** "Dados Pessoais" tab — read-only grid of patient identity fields. */
export default function DadosTab({ patient }) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="p-6 grid grid-cols-1 md:grid-cols-3 gap-5">
        <Field label="Nome completo">{patient.full_name}</Field>
        <Field label="Nome social">{patient.social_name}</Field>
        <Field label="Nome da mãe">{patient.mother_name}</Field>
        <Field label="CNS">{patient.cns}</Field>
        <Field label="CPF">{patient.cpf}</Field>
        <Field label="RG">{patient.rg}</Field>
        <Field label="Data de nascimento">{fmtDate(patient.birth_date)}</Field>
        <Field label="Sexo">{patient.sex}</Field>
        <Field label="Telefone">{patient.phone}</Field>
        <Field label="Telefone alternativo">{patient.phone_alt}</Field>
        <Field label="E-mail">{patient.email}</Field>
        <Field label="Endereço">{patient.address}</Field>
        <Field label="Bairro">{patient.neighborhood}</Field>
        <Field label="Cidade / UF">{[patient.city, patient.state].filter(Boolean).join("/")}</Field>
        <Field label="CEP">{patient.zip_code}</Field>
        <Field label="Observações">{patient.notes}</Field>
      </CardContent>
    </Card>
  );
}
